module.exports = __webpack_public_path__ + "static/mathematicians-delight-c5bac1602970c206986f5526d6855fd1.jpg";